import React, { useState } from "react";
import "./App.css";

const destinationsMap = {
  "Internship": 1,
  "Graduate": 2,
  "Fellowship": 3
};

const allDestinations = ["Saudi Arabia", "United Arab Emirates", "Qatar"];

function App() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    nationality: "",
    currentRole: "",
    message: "",
    programType: "",
    destinations: [],
    cvUrl: "",
    coverLetterUrl: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleDestinationChange = (destination) => {
    const max = destinationsMap[form.programType] || 0;
    let updated = [...form.destinations];

    if (updated.includes(destination)) {
      updated = updated.filter((d) => d !== destination);
    } else if (updated.length < max) {
      updated.push(destination);
    }

    setForm({ ...form, destinations: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      ...form,
      action: "submitApplication",
      destinations: form.destinations.join(", ")
    };

    const res = await fetch("https://script.google.com/macros/s/AKfycbxNM516zcDU0FmW1SZB62JhVAOFKPUKLidG0-QF6daWjiNZHO4sAGcPEyrDOykehINJQA/exec", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(data)
    });

    const json = await res.json();
    if (json.status === "success") {
      window.location.href = `https://theqiblapartners.com/thank-you.html?code=${json.code}`;
    } else {
      alert("Submission failed: " + json.message);
    }
  };

  return (
    <div className="container">
      <h2>Apply to The Qibla Partners Talent Program</h2>
      <form onSubmit={handleSubmit}>
        <label>Full Name <input name="fullName" required onChange={handleChange} /></label>
        <label>Email <input name="email" type="email" required onChange={handleChange} /></label>
        <label>Phone <input name="phone" required onChange={handleChange} /></label>
        <label>Nationality <input name="nationality" required onChange={handleChange} /></label>
        <label>Current Role <input name="currentRole" onChange={handleChange} /></label>
        <label>Message <textarea name="message" onChange={handleChange} /></label>
        <label>Program Type
          <select name="programType" required onChange={handleChange}>
            <option value="">-- Select --</option>
            <option>Internship</option>
            <option>Graduate</option>
            <option>Fellowship</option>
          </select>
        </label>
        <label>Destinations:</label>
        <div className="checkbox-group">
          {allDestinations.map((dest) => (
            <label key={dest}>
              <input
                type="checkbox"
                value={dest}
                checked={form.destinations.includes(dest)}
                onChange={() => handleDestinationChange(dest)}
              />
              {dest}
            </label>
          ))}
        </div>
        <label>CV URL <input name="cvUrl" type="url" required onChange={handleChange} /></label>
        <label>Cover Letter URL <input name="coverLetterUrl" type="url" onChange={handleChange} /></label>
        <button type="submit">Submit Application</button>
      </form>
    </div>
  );
}

export default App;